import { render, staticRenderFns } from "./dispatch.vue?vue&type=template&id=6f082aa0&scoped=true&"
import script from "./dispatch.vue?vue&type=script&lang=js&"
export * from "./dispatch.vue?vue&type=script&lang=js&"
import style0 from "./dispatch.vue?vue&type=style&index=0&id=6f082aa0&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f082aa0",
  null
  
)

export default component.exports